import type { ReactNode } from "react";

interface AdminPanelHeaderProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export default function AdminPanelHeader({
  icon,
  title,
  description,
}: AdminPanelHeaderProps) {
  return (
    <div className="d-flex align-items-center gap-3 mb-4 p-3 rounded-3 bg-project-gradient text-white shadow-sm">
      <div className="rounded-3 bg-white bg-opacity-25 p-3 d-flex align-items-center justify-content-center">
        {icon}
      </div>
      <div className="min-w-0">
        <h5 className="mb-0 fw-bold text-white">{title}</h5>
        <p className="mb-0 small text-white-50">{description}</p>
      </div>
    </div>
  );
}

